import axios from "axios";

const api = axios.create({
  baseURL: `/api`,
  withCredentials: true,
});

export const imgUrl = (u) =>
  u && u.startsWith("/api") ? `${u}` : u;

export const productAlt = (p) =>
  [p?.name, p?.material, p?.category_name].filter(Boolean).join(" — ") || "Premium metal home décor";

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(detail);
};

export default api;
